export default __webpack_public_path__ + "static/media/HubSpot.ad1a3b74.svg";